import type { QuestionnaireItem, QuestionnaireResponseItem } from "fhir/r3"
import { enableWhenConditionsMet } from "./enableWhenConditionsMet"

export function showQuestion(question: QuestionnaireItem, responses: QuestionnaireResponseItem[]): boolean {
  if (question.enableWhen == null) {
    return true
  }

  return enableWhenConditionsMet(question.enableWhen ?? [], responses)
}
